import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  finisheds: [],
  paymentsHistory: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalFinisheds: 0,
    totalPages: 0
  },
  finishedsCatalog: {},
  filterParams: '',
  isModalVisible: false
}

const mutations = {
  SET_FINISHEDS (state, payload) {
    state.finisheds = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalFinisheds: payload.total,
      totalPages: payload.last_page
    }
  },
  ADD_FINISHED (state, payload) {
    state.finisheds.unshift(payload)
  },
  UPDATE_FINISHED (state, payload) {
    const idx = state.finisheds.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.finisheds, idx, payload)
    }
  },
  DELETE_FINISHED (state, payload) {
    const idx = state.finisheds.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.finisheds, idx)
    }
  },
  DELETE_FINISHEDS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.finisheds.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.finisheds, idx)
      }
    }
  },
  SET_PAYMENTS_HISTORY (state, payload) {
    state.paymentsHistory = payload.data
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.finishedsCatalog[object] = payload.data
  },
  SET_FINISHEDS_CATALOG (state, payload) {
    state.finishedsCatalog = { ...state.finishedsCatalog, ...payload }
  },
  DISCARD_FINISHEDS_RECORD (state, payload) {
    const idx = state.finisheds.findIndex(e => e.id === payload.id)
    if (idx >= 0) {
      Vue.delete(state.finisheds, idx)
    }
  }
}

const actions = {
  async loadFinisheds ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`finisheds?page=${payload.page}${state.filterParams}&status=3&stage=4`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_FINISHEDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addFinished ({ commit }, payload) {
    const finished = {
      // columnas
      // sku: payload.sku,
    }

    app.$Progress.start()

    try {
      const response = await axios.post('finisheds', finished)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_FINISHED', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.finisheds', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editFinished ({ commit }, payload) {
    const finished = {
      // columnas
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`finisheds/${payload.id}`, finished)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_FINISHED', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.finisheds', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteFinished ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`finisheds/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_FINISHED', payload)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.finisheds', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteFinisheds ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`finisheds/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_FINISHEDS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.finisheds', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionProjectRestore ({ commit }, payload) {
    app.$Progress.start()
    try {
      const res = await axios.put(`/finisheds/${payload.id}/restore`)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DISCARD_FINISHEDS_RECORD', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionFinished ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`finisheds/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_FINISHED', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.finisheds', text: `finisheds.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/finisheds/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadFinishedsCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`finisheds/catalog`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.finisheds', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_FINISHEDS_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadPayments ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`payments?param=${payload.id},project_id`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.finisheds', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PAYMENTS_HISTORY', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  },
  loadEmployees ({ commit, dispatch, getters }, payload) {
    dispatch('ToQuotes/loadEmployees', payload, { root: true })
  },
  setModalContactVisible ({ commit, dispatch, getters }, payload) {
    dispatch('ProjectContacts/setModalContactVisible', { payload }, { root: true })
  }
}

const getters = {
  finisheds: state => state.finisheds,
  paymentsHistory: state => state.paymentsHistory,
  finishedsCatalog: state => state.finishedsCatalog,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  filterParams: state => state.filterParams,
  isModalContactVisible: (state, getters, rootState, rootGetters) => rootGetters['ProjectContacts/isModalContactVisible'],
  employees: (state, getters, rootState, rootGetters) => rootGetters['ToQuotes/employees']
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
